import type { IAppointmentDataType } from "@api/appointmentData";
import type { ID } from "@constants";
import { generatePath } from "@routes/generatePath.ts";

const viewHealthRecordRoute = "/health-record/:type/view/:id";

export const path = {
  list: {
    route: "/health-record/",
    link: () => path.list.route,
  },
  followup: {
    route: "/health-record/followup/",
    link: () => path.followup.route,
  },
  referral: {
    route: "/health-record/referral/",
    link: () => path.referral.route,
  },
  orders: {
    route: "/health-record/orders/",
    link: () => path.orders.route,
  },
  prescription: {
    route: "/health-record/prescription/",
    link: () => path.prescription.route,
  },
  experiments: {
    route: "/health-record/experiments/",
    link: () => path.experiments.route,
  },
  images: {
    route: "/health-record/images/",
    link: () => path.images.route,
  },
  view: {
    route: viewHealthRecordRoute,
    link: (type: IAppointmentDataType, id: ID) =>
      generatePath(viewHealthRecordRoute, { id, type }),
  },
};
